import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function VenueImage({ data }) {
  const { venueText, venueTitle, image } = data;
  return (
    <section className="bg-bg-1 md:pt-[95px] pt-[60px] lg:mt-[140px] mt-[70px]">
      <div
        className="container mx-auto px-4 3xl:px-0 w-full lg:w-[80%] relative
        xl:!max-w-[1400px] flex flex-col lg:gap-y-[98px] gap-y-10"
      >
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col lg:gap-y-[30px] gap-y-[10px] lg:max-w-[875px] lg:pl-[125px]"
        >
          <h3
            className="text-primary uppercase lg:text-[38px] text-[26px] lg:leading-[63px]
            leading-[35px] font-roboto-condensed-bold"
          >
            {venueTitle}
          </h3>
          <p className="lg:text-base text-[15px] leading-7 text-primary font-roboto-regular">
            {venueText}
          </p>
        </motion.div>
        <LazyLoadImage src={image.url} className="w-full h-full" />
      </div>
    </section>
  );
}
